module.exports = __webpack_public_path__ + "img/ico-share-qrcode.9004c643.png";